import React, { Component } from "react";
//import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem, IconButton } from "@material-ui/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import swal from "sweetalert";
import { SemipolarLoading } from "react-loadingg";
import { campaignZapierurlDetails, contactExport } from "../../../Queries";
import { fetchMethod } from "../../../FetchMethod";
class ExportToExcel extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, anchorEl: null, fileName: "NoOpp" };
  }

  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  ExcelRecieveddateFomate = date => {
    if (date !== null && date !== undefined) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      let time1 = date.getTime();
      let time2 = date.getTimezoneOffset() * 60000;
      date = time1 + time2;
      date = new Date(date);

      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();

      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      let date1 = `${dd}/${mm}/${yyyy}`;
      let time = hours + ":" + minutes + " " + am_pm;

      return (date = date1 + " " + time);
    }
  };
  formatDate1 = date => {
    if (date !== null && date !== undefined) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      date = `${dd}/${mm}/${yyyy}`;
      return (date = date + " " + time);
    }
  };
  exportToClick = event => {
    this.setState({ anchorEl: event.currentTarget });
    event.stopPropagation();
  };

  exportToClose = () => {
    this.setState({ anchorEl: null });
  };
  createExportHistory = async data => {
    var variables = {
      data
    };
    return await fetchMethod(contactExport, variables).then(response => {
      return response.json();
    });
  };
  setDataWithZapierurl = async campaignId => {
    return await fetchMethod(campaignZapierurlDetails(campaignId))
      .then(response => response.json())
      .then(responseAsJson => responseAsJson.data.Campaigns.zapierurl)
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  setDataWithZapier = fileData => {
    let filedata = [];
    fileData.length > 0
      ? fileData.map(item => {
          let steps = item.currentStage.Contactworkflowhistories;
        //  let List1 = steps[steps.length - 1];
          let Messages = item.Contactmessagesfk.Contactmessages;

          let message = [];
          Messages.map(m => {
            message.push(
              m.message +
                "\n" +
                this.ExcelRecieveddateFomate(m.messagedatetime) +
                "  (" +
                m.type +
                ")"
            );
          });
          let wholeMessages = message.join("\n \n");

          let executedonVisit = [];
          let x = steps.filter(step => {
            if (
              step.contactworkflowhistoryIbfk2rel.Campaignsteps[0].stepname ===
              "VISIT"
            ) {
              executedonVisit.push(step.executedon);
            }
          });
          let executedonFollow = [];
          let y = steps.filter(step => {
            if (
              step.contactworkflowhistoryIbfk2rel.Campaignsteps[0].stepname ===
              "FOLLOW"
            ) {
              executedonFollow.push(step.executedon);
            }
          });
          var movetolink = item.moveto;
          if (item.moveto == "" || item.moveto == null) {
            movetolink = "Zapier";
          }
          return filedata.push({
            contactid: item.id,
            campaignid: item.campaignid,
            Name: item.name,
            fname: item.fname,
            organization: item.organization,
            designation: item.designation,
            Location: item.location,
            Industry: item.industry,
            linkedinid: item.linkedinid,
            Email: item.email,
            phonenumber: item.phonenumber,
            Twitter: item.twitter,
            Skype: item.skype,
            DOB: item.dateofbirth,
            Visit: this.formatDate(executedonVisit[0]),
            Follow: this.formatDate(executedonFollow[0]),
            InvitationSent: item.InvitationSent,
            Connectedon: this.formatDate(item.connectedon),
            wholeMessages: wholeMessages,
            CurrentStage: item.CurrentStage,
            movedby: localStorage.getItem("id"),
            moveto: movetolink,

            LR: item.LR,
            Status:
              item.campaignstatus === "COMPLETED"
                ? "Completed"
                : item.campaignstatus === "PAUSE"
                ? "Pause"
                : item.campaignstatus === "LIVE"
                ? "Live"
                : ""
          });
        })
      : filedata.push({
          Name: "",
          fname: "",
          organization: "",
          designation: "",
          Location: "",
          Industry: "",
          linkedinid: "",
          Email: "",
          phonenumber: "",
          Twitter: "",
          Skype: "",
          DOB: "",
          Visit: "",
          Follow: "",
          InvitationSent: "",
          Connectedon: "",
          wholeMessages: "",
          CurrentStage: "",
          LR: "",
          Status: "",
          contactid: "",
          campaignid: "",
          movedby: "",
          moveto: ""
        });
    return filedata;
  };
  setDataWithHeader = fileData => {
    let filedata = [];
    fileData.length > 0
      ? fileData.map(item => {
          let steps = item.currentStage.Contactworkflowhistories;
          let List1 = steps[steps.length - 1];
          let Messages = item.Contactmessagesfk.Contactmessages;
          let message = [];
          Messages.map(m => {
            message.push(this.ExcelRecieveddateFomate(m.messagedatetime));

            message.push(m.message);
          });
          let wholeMessages = message.join("\n");

          let executedonVisit = [];
          let x = steps.filter(step => {
            if (
              step.contactworkflowhistoryIbfk2rel.Campaignsteps[0].stepname ===
              "VISIT"
            ) {
              executedonVisit.push(step.executedon);
            }
          });
          let executedonFollow = [];
          let y = steps.filter(step => {
            if (
              step.contactworkflowhistoryIbfk2rel.Campaignsteps[0].stepname ===
              "FOLLOW"
            ) {
              executedonFollow.push(step.executedon);
            }
          });
          return filedata.push({
            Name: item.name,
            "First Name": item.fname,
            "Current Company": item.organization,
            "Current Position": item.designation,
            Location: item.location,
            Industry: item.industry,
            "Linkedin Url": item.linkedinid,
            Email: item.email,
            "Phone ": item.phonenumber,
            Twitter: item.twitter,
            Skype: item.skype,
            DOB: item.dateofbirth,
            Visit: this.formatDate(executedonVisit[0]),
            Follow: this.formatDate(executedonFollow[0]),
            "Invitation Sent": item.InvitationSent,
            "Connected On": this.formatDate(item.connectedon),
            "Messages Notes": wholeMessages,
            "Current Stage": item.CurrentStage,

            "Last Response": item.LR,
            Status:
              item.campaignstatus === "COMPLETED"
                ? "Completed"
                : item.campaignstatus === "PAUSE"
                ? "Pause"
                : item.campaignstatus === "LIVE"
                ? "Live"
                : ""
          });
        })
      : filedata.push({
          Name: "",
          "First Name": "",
          "Current Company": "",
          "Current Position": "",
          Location: "",
          Industry: "",
          "Linkedin Url": "",
          Email: "",
          "Phone ": "",
          Twitter: "",
          Skype: "",
          DOB: "",
          Visit: "",
          Follow: "",
          "Invitation Sent": "",
          "Connected On": "",
          "Messages Notes": "",
          "Current Stage": "",
          "Last Response": "",
          Status: ""
        });
    return filedata;
  };

  setDataWithHeader = fileData => {
    let filedata = [];

    fileData.length > 0
      ? fileData.map(item => {
          let steps = item.currentStage.Contactworkflowhistories;
          let List1 = steps[steps.length - 1];
          let Messages = item.Contactmessagesfk.Contactmessages;
          let message = [];
          Messages.map(m => {
            message.push(this.ExcelRecieveddateFomate(m.messagedatetime));

            message.push(m.message);
          });
          let wholeMessages = message.join("\n");
          let executedonVisit = [];
          let x = steps.filter(step => {
            if (
              step.contactworkflowhistoryIbfk2rel.Campaignsteps[0].stepname ===
              "VISIT"
            ) {
              executedonVisit.push(step.executedon);
            }
          });
          let executedonFollow = [];
          let y = steps.filter(step => {
            if (
              step.contactworkflowhistoryIbfk2rel.Campaignsteps[0].stepname ===
              "FOLLOW"
            ) {
              executedonFollow.push(step.executedon);
            }
          });
          return filedata.push({
            Name: item.name,
            "First Name": item.fname,
            "Current Company": item.organization,
            "Current Position": item.designation,
            Location: item.location,
            Industry: item.industry,
            "Linkedin Url": item.linkedinid,
            Email: item.email,
            "Phone ": item.phonenumber,
            Twitter: item.twitter,
            Skype: item.skype,
            DOB: item.dateofbirth,
            Visit: this.formatDate(executedonVisit[0]),
            Follow: this.formatDate(executedonFollow[0]),
            "Invitation Sent": item.InvitationSent,
            "Connected On": this.formatDate(item.connectedon),
            "Messages Notes": wholeMessages,
            "Current Stage": item.CurrentStage,

            "Last Response": item.LR,
            Status:
              item.campaignstatus === "COMPLETED"
                ? "Completed"
                : item.campaignstatus === "PAUSE"
                ? "Pause"
                : item.campaignstatus === "LIVE"
                ? "Live"
                : ""
          });
        })
      : filedata.push({
          Name: "",
          "First Name": "",
          "Current Company": "",
          "Current Position": "",
          Location: "",
          Industry: "",
          "Linkedin Url": "",
          Email: "",
          "Phone ": "",
          Twitter: "",
          Skype: "",
          DOB: "",
          Visit: "",
          Follow: "",
          "Invitation Sent": "",
          "Connected On": "",
          "Messages Notes": "",
          "Current Stage": "",
          "Last Response": "",
          Status: ""
        });
    return filedata;
  };

  exportToExcel = (fileData, fileName) => {
    if (this.props.fileData && this.props.fileData.length > 0) {
      let filedata = this.setDataWithHeader(fileData);
      try {
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const name = "NoOpp";
        const ws = XLSX.utils.json_to_sheet(filedata);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array"
        });
        const data = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(data, name + fileExtension);
        this.exportToClose();
      } catch (e) {
        swal("Error", { icon: "error" });
      }
      this.setState({ loading: false });
    } else {
      this.setState({ loading: true });
      setTimeout(() => {
        this.exportToExcel(this.props.fileData, fileName);
      }, 5000);
    }
  };

  exportToZapier = async salesforceData => {
    var urldata = await this.setDataWithZapierurl(
      this.props.fileData[0].campaignid
    );
    var selectedcontactData = this.props.fileData;
    let selectedArrayIds2 = [];
    if (salesforceData.length == selectedcontactData.length) {
      let filedata = this.setDataWithZapier(selectedcontactData);

      selectedArrayIds2 = filedata;
    } else {
      salesforceData.map(a => {
        selectedcontactData.map(b => {
          if (a.id == b.id) {
            selectedArrayIds2.push({
              campaignid: b.campaignid,
              moveto: urldata,
              Contactmessagesfk: b.Contactmessagesfk,
              campaignstatus: b.campaignstatus,
              connect: b.connect,
              connectedon: b.connectedon,
              contactstatus: b.contactstatus,
              CurrentStage: b.CurrentStage,
              currentStage: b.currentStage,
              currentstatus: b.currentstatus,
              dateofbirth: b.dateofbirth,
              designation: b.designation,
              email: b.email,
              fname: b.fname,
              id: b.id,
              industry: b.industry,
              InvitationSent: b.InvitationSent,
              linkedinid: b.linkedinid,
              location: b.location,
              name: b.name,
              organization: b.organization,
              phonenumber: b.phonenumber,
              profileimage: b.profileimage,
              skype: b.skype,
              thanksmsgdate: b.thanksmsgdate,
              twitter: b.twitter,
              Visit: b.Visit,
              Follow: b.Follow
            });
          }
        });
      });

      let filedata = this.setDataWithZapier(selectedArrayIds2);
      selectedArrayIds2 = filedata;
    }
    if (urldata != "" && urldata != null) {
      var urldata = await this.createExportHistory(selectedArrayIds2);
      let selectedArrayIds = selectedArrayIds2;
      var dataT = JSON.stringify(selectedArrayIds);
      var request = require("request");
      var options = {
        method: "POST",
        url: urldata,
        headers: {
          "Content-Type": "text/plain"
        },
        body: dataT
      };
      this.exportToClose();
      request(options, function(error, response) {
        if (error) {
          swal("Please try again later", { icon: "warning" });
        } else {
          swal("Successfully moved to Zapier", { icon: "success" });
        }
      });
    } else {
      swal(
        "Please configure the Zapier Integration URL on Campaign Details page",
        { icon: "warning" }
      );
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={70} color={"#3865dd"} />
        </div>
      );
    }
    const { anchorEl, fileData, fileName } = this.state;
    return (
      <div class="Export">
        <IconButton
          style={{ fontSize: "1rem", color: "#36454d" }}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={this.exportToClick}
        >
          Export as
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.exportToClose}
        >
          <MenuItem onClick={this.exportToClose} disabled>
            Export to
          </MenuItem>
          <MenuItem
            onClick={() => this.exportToZapier(this.props.SalesHubdata)}
          >
            Zapier
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.exportToExcel(this.props.fileData, fileName);
            }}
          >
            Excel
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default ExportToExcel;
